<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">{{$t('dashboard')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/department">{{$t('department')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
                <b-row>
                    <b-col md="6">
                        <!--<b-row>
                            <b-col md="4"><label class="labels">ID Department</label></b-col>
                            <b-col md="8"><p>{{ model.code !== null ? model.code : '-' }}</p></b-col>
                        </b-row>-->
                        <b-row>
                          <b-col md="4"><label class="labels">{{$t('department')}}</label></b-col>
                          <b-col md="8"><p>{{ model.name !== null ? model.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">Email</label></b-col>
                          <b-col md="8"><p>{{ model.email !== null ? model.email : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">{{$t('company')}}</label></b-col>
                          <b-col md="8"><p>{{ model.company !== null ? model.company.name : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="4"><label class="labels">{{$t('branch')}}</label></b-col>
                          <b-col md="8"><p>{{ model.branch !== null ? model.branch.name : '-' }}</p></b-col>
                        </b-row>
                        <!-- <b-row>
                          <b-col md="4"><label class="labels">Telephone</label></b-col>
                          <b-col md="8"><p>{{ model.phone }} {{ model.extPhone === '' ? '' : '- ' + model.extPhone }}</p></b-col>
                        </b-row> -->
                        <!-- <b-row>
                          <b-col md="4"><label class="labels">Fax</label></b-col>
                          <b-col md="8"><p>{{ model.fax !== null ? model.fax : '-' }}</p></b-col>
                        </b-row> -->
                    </b-col>
                </b-row>
            </b-form>
            <b-button class="mt-3" :to="'/company-structure/department'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" :to="'/company-structure/department/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </b-card>
    </div>
</template>

<script>

    export default {
        name: 'department-details',
        data () {
            return {
                isLoading: false,
                apiUrl: {
                    department: window.AppConfig.apiUrl + 'department'
                },
                model: {
                    code: '',
                    name: '',
                    branch: null,
                    company: null,
                    phone: '',
                    extPhone: '',
                    fax: '',
                    email: '',
                    isActive: true,
                }
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.department + '/' + this.$route.params.uuid).then(response => {
                  this.model.code = response.data.code !== null ? response.data.code : '-'
                  this.model.name = response.data.name !== null ? response.data.name : '-'
                  this.model.branch = response.data.branch !== null ? response.data.branch : '-'
                  this.model.company = response.data.company !== null ? response.data.company : '-'
                  this.model.phone = response.data.phone !== null ? response.data.phone : '-'
                  this.model.extPhone = response.data.extPhone !== null ? response.data.extPhone : '-'
                  this.model.fax = response.data.fax !== null ? response.data.fax : '-'
                  this.model.email = response.data.email !== null ? response.data.email : '-'
                  this.model.isActive = response.data.isActive !== null ? response.data.isActive : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('DD MMM YYYY HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'success'
                    break
                case 1:
                    return 'info'
                    break
                }
            }
        }
    }
</script>